import styled from "styled-components"

type StyledProps = {
  $templateColumns: string
}

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  padding: 2rem;
  border-radius: 0.6rem;
  margin-bottom: 2rem;
`

export const Row = styled.div<StyledProps>`
  display: grid;
  grid-template-columns: ${(p) => p.$templateColumns};
`
